export enum Fachrichtung {
  ALLGEMEINCHIRURGIE = 'Allgemeinchirurgie',
  ALLGEMEINMEDIZIN = 'Allgemeinmedizin',
  AUGENHEILKUNDE = 'Augenheilkunde',
  ERGOTHERAPIE = 'Ergotherapie',
  HEILPRAKTIKER = 'Heilpraktiker',
  INNERE_MEDIZIN = 'Innere Medizin',
  KIEFERORTHOPAEDIE = 'Kieferorthopädie',
  KINDER_UND_JUGENDPSYCHIATRIE_UND_PSYCHOTHERAPIE = 'Kinder- und Jugendpsychiatrie und -psychotherapie',
  KINDERHEILKUNDE_KINDER_UND_JUGENDMEDIZIN = 'Kinderheilkunde / Kinder- und Jugendmedizin',
  NEUROLOGIE = 'Neurologie',
  ORTHOPAEDIE = 'Orthopädie',
  ORTHOPAEDIE_UND_UNFALLCHIRURGIE = 'Orthopädie und Unfallchirurgie',
  PHYSIKALISCHE_UND_REHABILITATIVE_MEDIZIN = 'Physikalische und Rehabilitative Medizin',
  PHYSIOTHERAPIE = 'Physiotherapie',
  PLASTISCHE_CHIRURGIE = 'Plastische Chirurgie',
  PSYCHIATRIE_UND_PSYCHOTHERAPIE = 'Psychiatrie und Psychotherapie',
  PSYCHOLOGISCHER_PSYCHOTHERAPEUT = 'Psychologischer Psychotherapeut',
  ZAHNMEDIZIN = 'Zahnmedizin',
  SONSTIGES = 'Sonstiges',
}
